export default "__VITE_ASSET__dB3UiK88__"